import { MEDIA } from "@/lib/constants";

export default function Authority() {
    return (
        <section
            id="authority"
            data-testid="section-authority"
            className="bg-white py-24 lg:py-32 border-y border-cream"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
                {/* Author block */}
                <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center reveal">
                    <div className="lg:col-span-5">
                        <div className="relative rounded-[2rem] overflow-hidden shadow-2xl max-w-md mx-auto">
                            <img
                                src={MEDIA.founderPhoto}
                                alt="Autor do método Inglês Destravado em 30 Dias"
                                className="w-full h-auto object-cover"
                            />
                        </div>
                    </div>
                    <div className="lg:col-span-7">
                        <div className="flex items-center gap-3 mb-5">
                            <span className="hairline w-10" />
                            <span className="label-eyebrow">
                                Sobre quem te ensina
                            </span>
                        </div>
                        <h2 className="font-serif text-emerald-brand text-3xl sm:text-4xl lg:text-5xl leading-[1.1] tracking-tight">
                            Eu já fui o cara que{" "}
                            <span className="italic text-gold-brand">
                                travava
                            </span>
                            . Hoje, ensino o caminho inverso.
                        </h2>
                        <div className="mt-6 space-y-4 text-lg text-emerald-light/90 leading-relaxed">
                            <p>
                                Estudei inglês a vida inteira na escola. Tirava
                                nota boa em prova, mas na primeira viagem, na
                                primeira reunião, na primeira conversa real —
                                eu congelava.
                            </p>
                            <p>
                                Quando descobri como os poliglotas realmente
                                aprendem (não é o que te ensinaram), tudo mudou.
                                Em poucos meses, eu estava conversando, viajando
                                e fechando oportunidades em inglês.
                            </p>
                            <p className="font-serif italic text-emerald-brand">
                                Esse e-book é exatamente o método que eu
                                gostaria de ter recebido lá atrás.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
